import { render, staticRenderFns } from "./ElementsDragItems.vue?vue&type=template&id=6549d90e"
import script from "./ElementsDragItems.vue?vue&type=script&lang=js"
export * from "./ElementsDragItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports